import Snackbar from '../Snackbar';
import ua from '@tencent/docs-user-agent';
import { i18n } from '../../common/locale';
export var canDownloadImageByTencentApp = ua.isTencentDocsApp && ua.isTencentDocsAppVersionAboveOrEqual('2.9.2');
export function toastDownloadMessage(saveSucceed) {
    if (saveSucceed) {
        Snackbar.show({
            message: i18n('saveImageSucceeded'), duration: 3000, autoClose: true, zIndex: 10003, type: 'success',
        });
    }
    else {
        Snackbar.show({
            message: i18n('saveImageFailed'), duration: 3000, autoClose: true, zIndex: 10003, type: 'error',
        });
    }
}
export function saveImageByTencentApp(src) {
    if (!canDownloadImageByTencentApp) {
        return;
    }
    if (ua.isAndroid) {
        var jsApi = window.jsApi;
        jsApi && jsApi.invokeNative && jsApi.invokeNative('ui', 'savePublicImg', {
            cmd: 'saveguide',
            content: src,
        }, function (rsp) {
            toastDownloadMessage(rsp.result.errCode === 0);
        });
    }
    else if (ua.isIOS) {
        var mqq = window.mqq;
        mqq && mqq.invoke && mqq.invoke('ui', 'savePublicImg', {
            cmd: 'saveguide',
            content: src,
        }, function (rsp) {
            toastDownloadMessage(rsp.data.errCode === 0);
        });
    }
}
function getDefaultActionSheet(imageList) {
    var supportNativeInterface = (ua.isAndroid && window.jsApi && window.jsApi.invokeNative)
        || (ua.isIOS && window.mqq && window.mqq.invoke);
    if (!canDownloadImageByTencentApp || !supportNativeInterface) {
        return null;
    }
    return [{
            id: i18n('saveImage'),
            onClick: function (imageIndex) {
                if (canDownloadImageByTencentApp) {
                    saveImageByTencentApp(imageList[imageIndex].url);
                }
            },
            disabled: !canDownloadImageByTencentApp,
        }];
}
export function getActionSheetConfig(images, actionSheetConfig) {
    if ((actionSheetConfig && actionSheetConfig.length === 0)) {
        return getDefaultActionSheet(images);
    }
    return actionSheetConfig;
}
export function nextFrame() {
    var currentTime = Date.now();
    return new Promise(function (resolve) { return requestAnimationFrame(function () {
        var frameTime = Date.now();
        resolve(frameTime - currentTime);
    }); });
}
export function calcClippedResult(image, clipStyle) {
    var clippedWidth = 0;
    var clippedHeight = 0;
    var clippedLeft = 0;
    var clippedTop = 0;
    if (!image) {
        return { clippedLeft: clippedLeft, clippedTop: clippedTop, clippedWidth: clippedWidth, clippedHeight: clippedHeight };
    }
    var naturalWidth = image.naturalWidth, naturalHeight = image.naturalHeight;
    clippedWidth = naturalWidth;
    clippedHeight = naturalHeight;
    if (clipStyle) {
        var width = clipStyle.width, height = clipStyle.height, marginLeft = clipStyle.marginLeft, marginTop = clipStyle.marginTop;
        clippedWidth = width <= 1 ? width * naturalWidth : width;
        clippedHeight = height <= 1 ? height * naturalHeight : height;
        clippedLeft = Math.abs(marginLeft) < 1 ? marginLeft * naturalWidth : marginLeft;
        clippedTop = Math.abs(marginTop) < 1 ? marginTop * naturalHeight : marginTop;
    }
    return { clippedLeft: clippedLeft, clippedTop: clippedTop, clippedWidth: clippedWidth, clippedHeight: clippedHeight };
}
